'use strict';

var AppDispatcher = require('dispatcher/SchedulerAppDispatcher');
var ActionTypes = require('constants/AppConstants').ActionTypes;

var SessionActionCreators = {

    updatingNewVersionApi: function() {
        AppDispatcher.dispatch({
            type: ActionTypes.NEW_VERSION_API
        });
    },

    saveSettingModal: function() {
        AppDispatcher.dispatch({
            type: ActionTypes.SAVE_CONFIGURATION_SETTINGS
        });
    }
};

module.exports = SessionActionCreators;




/** WEBPACK FOOTER **
 ** ./src/actions/AppActionCreators.js
 **/